import type { AnswerValue } from "./AnswerValue";

export function isValidAnswer(val: unknown): val is AnswerValue {
    return (
        typeof val === "string" ||
        typeof val === "boolean" ||
        (Array.isArray(val) && val.every(item => typeof item === "string")) ||
        val instanceof File
    );
}
